import React from 'react';

import Uuid from '../../../../../support/Uuid';
import ContabilidadForm from './ContabilidadForm ';

const ContabilidadManager = (props) => {

  const { entidad, editing } = props;

  const handleOnAdd = (value) => {
    const newContabilidad = {
      id: Uuid.v4(),
      entidad: entidad.id,
      ...value,
    };

    props.onContabilidadAdd(newContabilidad);
  };

  const handleOnCloseForm = () => {
    props.onClose();
  }

  return (
    <>
      <ContabilidadForm
        data={ editing }
        onAdd={ handleOnAdd }
        onClose={ handleOnCloseForm }
      />
    </>
  );
};

export default ContabilidadManager;
